import React, { ReactElement, ReactNode } from "react";
import { useDispatch } from "react-redux";
import { Transition } from "react-transition-group";
import { AlternateMenuItemOnClick } from "./Category/CrudMenu";

export type TableOptionItem = {
  name: string;
  onClick(id: string | number): void;
  disabled: boolean;
  alternateMenuItemOnClick: null | ((id: string | number) => void);
  customItem?: (props?: any) => ReactNode;
};

type TableOptionsProps = {
  id: string | number;
  visibleOptions: string | number | null;
  close(): void;
  optionList: TableOptionItem[];
  additionalIdColumns?: any;
};

type Props = TableOptionsProps;

const RowOptions: React.FC<Props> = ({
  id,
  visibleOptions,
  close,
  optionList,
  additionalIdColumns,
}) => {
  return (
    <Transition
      in={visibleOptions === id}
      timeout={50}
      mountOnEnter
      unmountOnExit
    >
      {transitionState => (
        <ClickOutsideDetector onClickOutside={() => close()}>
          <div className={"OptionsList " + transitionState}>
            {optionList.map(item => {
              const { customItem, ...otherItems } = item;

              return customItem ? (
                <CustomRowOptionItem
                  {...{
                    ...item,
                    additionalDataIDs: additionalIdColumns,
                  }}
                />
              ) : (
                <span
                  className={`OptionItem ${item.disabled ? "Disabled" : ""}`}
                  onClick={() => {
                    if (item.alternateMenuItemOnClick) {
                      item.alternateMenuItemOnClick(id);
                    } else {
                      item.onClick(id);
                    }
                    close();
                  }}
                  key={item.name}
                >
                  {item.name}
                </span>
              );
            })}
          </div>
        </ClickOutsideDetector>
      )}
    </Transition>
  );
};

export { RowOptions };

type ClickOutsideDetectorProps = {
  onClickOutside(): void;
};

const ClickOutsideDetector: React.FC<ClickOutsideDetectorProps> = ({
  onClickOutside,
  children,
}) => {
  return (
    <div>
      <div className="ClickOutsideDetector" onClick={onClickOutside} />
      {children}
    </div>
  );
};

const CustomRowOptionItem: React.FC<any> = (optionItemProps: any) => {
  const { customItem, ...otherItemProps } = optionItemProps;
  // return <>{ customItem(otherItemProps)}</>
  return customItem(otherItemProps); // customItem({...otherItemProps});
};
